module.exports = __webpack_public_path__ + "static/media/sysgesa_screenshot.bcdb65be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/sysgesa_screenshot.png
// module id = 238
// module chunks = 0